import React, { useState } from "react";
import "./Payment_gateway.css";

const API_BASE = "";

function Payment_gateway() {
    const [amount, setAmount] = useState("1000");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [messageType, setMessageType] = useState("");
    const [paymentDetails, setPaymentDetails] = useState(null);

    const showMessage = (text, type = "info") => {
        setMessage(text);
        setMessageType(type);
    };

    const handlePayment = async (e) => {
        e.preventDefault();

        setMessage("");
        setPaymentDetails(null);

        const rupees = Number(amount);

        if (!Number.isFinite(rupees) || rupees <= 0) {
            showMessage("Please enter a valid amount.", "error");
            return;
        }

        if (!Number.isSafeInteger(Math.round(rupees * 100))) {
            showMessage("Please enter a smaller amount.", "error");
            return;
        }

        if (!window.Razorpay) {
            showMessage(
                "Razorpay Checkout is not loaded. Please refresh the page.",
                "error"
            );
            return;
        }

        setLoading(true);

        try {
            // STEP 1: Ask Flask to create a Razorpay order.
            const orderResponse = await fetch(
                `${API_BASE}/api/payments/create-order`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        amount_paise: Math.round(rupees * 100),
                    }),
                }
            );

            const orderData = await orderResponse.json();

            if (!orderResponse.ok) {
                throw new Error(
                    orderData.message ||
                    orderData.error ||
                    "Unable to create payment order."
                );
            }

            // STEP 2: Open Razorpay Checkout.
            const options = {
                key: orderData.key_id,
                amount: orderData.amount,
                currency: orderData.currency,
                name: "HYDAX",
                description: "Online Payment",
                order_id: orderData.order_id,

                prefill: {
                    name: "",
                    email: "",
                    contact: "",
                },

                theme: {
                    color: "#e91e8f",
                },

                handler: async (response) => {
                    // STEP 3: Verify the payment with Flask.
                    showMessage("Verifying payment...", "info");

                    try {
                        const verifyResponse = await fetch(
                            `${API_BASE}/api/payments/verify`,
                            {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                },
                                body: JSON.stringify({
                                    razorpay_order_id:
                                        response.razorpay_order_id,
                                    razorpay_payment_id:
                                        response.razorpay_payment_id,
                                    razorpay_signature:
                                        response.razorpay_signature,
                                }),
                            }
                        );

                        const verifyData = await verifyResponse.json();

                        if (!verifyResponse.ok) {
                            throw new Error(
                                verifyData.error ||
                                "Payment verification failed."
                            );
                        }

                        setPaymentDetails(verifyData);

                        if (verifyData.captured) {
                            showMessage(
                                "Payment successful!",
                                "success"
                            );
                        } else {
                            showMessage(
                                `Payment received for verification. Current status: ${
                                    verifyData.payment_status
                                }. Please wait for confirmation.`,
                                "info"
                            );
                        }
                    } catch (error) {
                        showMessage(
                            error.message ||
                            "Unable to verify payment.",
                            "error"
                        );
                    } finally {
                        setLoading(false);
                    }
                },

                modal: {
                    ondismiss: () => {
                        setLoading(false);
                        showMessage(
                            "Payment window closed. No success confirmation received.",
                            "info"
                        );
                    },
                },
            };

            const checkout = new window.Razorpay(options);

            checkout.on("payment.failed", (response) => {
                setLoading(false);

                showMessage(
                    response.error?.description ||
                    "Payment failed. Please try again.",
                    "error"
                );
            });

            checkout.open();
        } catch (error) {
            setLoading(false);

            showMessage(
                error.message || "Something went wrong.",
                "error"
            );
        }
    };

    return (
        <div className="payment-gateway-page">
            <div className="payment-gateway-card">

                <div className="payment-heading">
                    <div className="payment-icon">?</div>

                    <h2>HYDAX Payment Gateway</h2>

                    <p>
                        Make a secure online payment
                    </p>
                </div>

                <form onSubmit={handlePayment}>
                    <label htmlFor="payment-amount">
                        Enter Amount (INR)
                    </label>

                    <div className="amount-input">
                        <span>?</span>

                        <input
                            id="payment-amount"
                            type="number"
                            min="1"
                            step="0.01"
                            value={amount}
                            onChange={(e) =>
                                setAmount(e.target.value)
                            }
                            placeholder="Enter amount"
                            required
                            disabled={loading}
                        />
                    </div>

                    <button
                        className="pay-now-button"
                        type="submit"
                        disabled={loading}
                    >
                        {loading
                            ? "Processing..."
                            : `Pay ?${(
                                Number(amount) || 0
                            ).toFixed(2)}`}
                    </button>
                </form>

                {message && (
                    <div
                        className={`payment-alert ${messageType}`}
                        role="status"
                    >
                        {message}
                    </div>
                )}

                {paymentDetails && (
                    <div className="payment-result">
                        <h3>Payment Details</h3>

                        <p>
                            <strong>Payment ID:</strong>{" "}
                            {paymentDetails.payment_id}
                        </p>

                        <p>
                            <strong>Order ID:</strong>{" "}
                            {paymentDetails.order_id}
                        </p>

                        <p>
                            <strong>Status:</strong>{" "}
                            {paymentDetails.payment_status}
                        </p>
                    </div>
                )}

                <div className="payment-footer">
                    <span>?? Secure checkout powered by Razorpay</span>
                </div>
            </div>
        </div>
    );
}

export default Payment_gateway;